import { render } from "./ReasonsForDeliveryFailureManagement.html?vue&type=template&id=784cfdf8&scoped=true"
import script from "./ReasonsForDeliveryFailureManagement.js?vue&type=script&lang=js"
export * from "./ReasonsForDeliveryFailureManagement.js?vue&type=script&lang=js"

import "./ReasonsForDeliveryFailureManagement.css?vue&type=style&index=0&id=784cfdf8&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784cfdf8"]])

export default __exports__